// mui
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import DeleteIcon from '@material-ui/icons/Delete'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
// react
import { useState, useEffect, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getUserId } from '../reducks/users/selectors'
import styled from 'styled-components'
// firebase
import { db } from '../firebase'

const CartListItem = (props) => {
    const selector = useSelector(state=>state)
    const uid = getUserId(selector)
    const cartId = props.product.cartId
    const image = props.product.images[0].path
    const name = props.product.name
    const variationName = props.product.variationName
    const brand = props.product.brand

    // 割引後価格
    const discountedPrice = useMemo(()=>{
        return Math.round( props.product.price * (1 - props.product.discount / 100) )
    }, [props.product.price, props.product.discount])

    const [quantity, setQuantity] = useState(1)

    const decrement = useCallback(()=>{
        setQuantity(quantity - 1)
        db.collection('users').doc(uid)
          .collection('cart').doc(cartId)
          .set({quantity: quantity - 1},{merge:true})
    }, [uid, cartId, quantity])
    const increment = useCallback(()=>{
        setQuantity(quantity + 1)
        db.collection('users').doc(uid)
          .collection('cart').doc(cartId)
          .set({quantity: quantity + 1},{merge:true})
    }, [uid, cartId, quantity])

    const removeProductFromCart = () => {
        db.collection('users').doc(uid)
          .collection('cart').doc(cartId).delete()
    }

    useEffect(()=>{
        db.collection('users').doc(uid)
          .collection('cart').doc(cartId).get()
          .then(snapshot => {
              const data = snapshot.data()
              setQuantity(data.quantity)
          })
    },[uid, cartId])

    return (
        <>
            <ListItemWrapper>
                <ListItemAvatar>
                    <ProductImage src={image} alt="商品画像" />
                </ListItemAvatar>

                <ProductInfo>
                    <ListItemText secondary={brand && brand.toUpperCase()}/>
                    <ListItemText primary={name} secondary={variationName} />
                    <span>{discountedPrice && '¥' + discountedPrice.toLocaleString()}</span>
                    {props.product.discount ? (
                        <DiscountTag>{props.product.discount + '%OFF'}</DiscountTag>
                    ):(
                        <></>
                    )}
                </ProductInfo>
                {props.fixed ? (
                    <CartActions>
                        数量：{quantity}
                    </CartActions>
                ) : (
                    <CartActions>
                        <IconButton disabled={quantity <= 1} onClick={decrement}>
                            <RemoveCircleIcon />
                        </IconButton>
                        {quantity}
                        <IconButton onClick={increment}>
                            <AddCircleIcon />
                        </IconButton>
                        <IconButton onClick={removeProductFromCart}>
                            <DeleteIcon />
                        </IconButton>
                    </CartActions>
                )}
            </ListItemWrapper>
            <Divider/>
        </>
    )
}

export default CartListItem

const ListItemWrapper = styled(ListItem)`
    height: 160px;
    display: flex;
    flex-direction: row;
    @media screen and (max-width:768px){
        width: 100%;
        height: auto;
        flex-wrap: wrap;
    }
`
const ProductImage = styled.img`
    object-fit: contain;
    width: 96px;
    height: 96px;
`
const ProductInfo = styled.div`
    padding-left: 16px;
    flex: 1;
`
const DiscountTag = styled.span`
    width: 80px;
    padding: 5px 10px;
    display: inline;
    text-align: center;
    color: #000;
    background-color: #FCEB04;
    border-radius: 3px;
    font-size: 12px; 
    margin-left: 10px;
    @media screen and (max-width:768px){
        font-size: 10px; 
        padding: 2px 5px;
    }
`
const CartActions = styled.div`
    min-width: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 5px 0;
        margin: 10px 50px;
        font-size: .9rem;
        background-color: #777;
    }
`